module.exports = __webpack_public_path__ + "static/media/ag.7a5c6f51.svg";